export class ActionLogModel {
    riskId?: number;
    action: string;
    section: string;
    createDate: string;
    createBy: string;
  }
  